import React, {FunctionComponent} from 'react';
import {Button} from '@mui/material';
import UserInformation from './UserInformation/UserInformation';
import SetNewPassword from './SetNewPassword/SetNewPassword';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import {Container} from '@mui/system';
import {useTranslation} from 'react-i18next';
import UpdateYourEmail from './UpdateYourEmail/UpdateYourEmail';
import { useDispatch } from 'react-redux';
import {AppDispatch, store} from '../../store/store';
import { push } from '@lagunovsky/redux-react-router';
import useTitle from '../../helpers/use-title';
// import UpdateYourLanguage from './UpdateYourLanguage/UpdateYourLanguage';
import {redirectBack} from "../../store/middlewares/redirect";
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
const Settings: FunctionComponent = () => {

  const {t} = useTranslation(['settings']);

  const dispatch = useDispatch<AppDispatch>();

  const onClickBack = () => {
      dispatch(redirectBack());
  }

  useTitle( t( 'your-user-data' ) );

  return (
    <AppLayout
      title={ t( 'your-user-data' ) }
      onBack={ onClickBack }
    >
      <div className="page page-settings">
        <Container sx={{mt: 4}}>
          <div className="settings-page">
            <UserInformation/>
            <UpdateYourEmail/>
            {/* <UpdateYourLanguage /> */}
            <SetNewPassword/>
          </div>
          <Button
            variant="outlined"
            sx={{my: 4,}}
            onClick={onClickBack}
          >{t('back')}</Button>
        </Container>
      </div>
    </AppLayout>
  );
}

export default Settings;
